import * as Pixi from "@frog/source/pixi.js"

const resources = [
    {"file": require("@frog/source/images/ld47/Level 1 Background.png").default},
    {"file": require("@frog/source/images/ld47/Level 2 Background.png").default},
    {"file": require("@frog/source/images/ld47/Level 3 Background.png").default},
    {"file": require("@frog/source/images/ld47/Level 4 Background.png").default},
    {"file": require("@frog/source/images/ld47/Level 5 Background.png").default},
    {"file": require("@frog/source/images/ld47/Level 1 building.png").default},
    {"file": require("@frog/source/images/ld47/Level 2 building.png").default},
    {"file": require("@frog/source/images/ld47/Level 3 Building.png").default},
    {"file": require("@frog/source/images/ld47/Level 4 Building.png").default},
    {"file": require("@frog/source/images/ld47/Level 5 building.png").default},
    {"file": require("@frog/source/images/ld47/ludumDare47_characterUnit1.png").default},
    {"file": require("@frog/source/images/ld47/ludumDare47_characterUnit2.png").default},
    {"file": require("@frog/source/images/ld47/ludumDare47_characterUnit3.png").default},
    {"file": require("@frog/source/images/ld47/ludumDare47_characterUnit4.png").default},
    {"file": require("@frog/source/images/ld47/baddie.png").default},
    {"file": require("@frog/source/images/ld47/characterUnit2_chain.png").default},
    {"file": require("@frog/source/images/ld47/characterUnit2_hook.png").default},
    {"file": require("@frog/source/images/ld47/characterUnit4_swirl.png").default},
    {"file": require("@frog/source/images/ld47/hpBar_empty.png").default},
    {"file": require("@frog/source/images/ld47/hpBar.png").default},
    {"file": require("@frog/source/images/ld47/invoke skill range.png").default},
    {"file": require("@frog/source/images/ld47/move range.png").default},
    {"file": require("@frog/source/images/ld47/Level 2 Fence.png").default},
    {"file": require("@frog/source/images/ld47/Level 3 Fence - background.png").default},
    {"file": require("@frog/source/images/ld47/Level 3 Fence.png").default},
    {"file": require("@frog/source/images/ld47/Level 5 Fence - background.png").default},
    {"file": require("@frog/source/images/ld47/Level 5 Fence.png").default},
    {"file": require("@frog/source/images/south.png").default},
    {"file": require("@frog/source/images/east.png").default},
    {"file": require("@frog/source/images/west.png").default},
    {"file": require("@frog/source/images/north.png").default},
    {"file": require("@frog/source/images/south-arrow.png").default},
    {"file": require("@frog/source/images/east-arrow.png").default},
    {"file": require("@frog/source/images/west-arrow.png").default},
    {"file": require("@frog/source/images/north-arrow.png").default},
    {"file": require("@frog/source/images/north-south.png").default},
    {"file": require("@frog/source/images/west-south.png").default},
    {"file": require("@frog/source/images/west-north.png").default},
    {"file": require("@frog/source/images/west-east.png").default},
    {"file": require("@frog/source/images/east-south.png").default},
    {"file": require("@frog/source/images/east-north.png").default},
]

const loader = new Pixi.Loader()
// loader.onProgress.add(function() {
//     console.log(...arguments)
// })
// loader.onLoad.add(function() {
//     console.log("onLoad", ...arguments)
// })
if(resources.length > 0) {
    loader.status = "started"
    loader.add(resources.map((resource) => resource.file))
}
loader.load(function() {
    loader.status = "finished"
})

export default loader
